import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';

import copyToClipboard from 'utils/copyToClipboard';
import { useToast } from 'utils/context/ToastContext';

const Teacher = ({ organizationId, courseId, id, showDeleteButton, published, claim_token, organization_slug, onConfirmDelete }) => {
  
  const { showToast } = useToast();
  
  const handleCopyLink = () => {
    const claimLink = `${window.location.origin}/${organization_slug}/memberships/${claim_token}`;
    copyToClipboard(claimLink, showToast);
  };

  return (
    <div>
        {published ?
          <MenuItem component={Link} to={ `/organizations/${organizationId}/collections/${courseId}/collectible/${id}/edit` } disableRipple>
            <RemoveRedEyeIcon fontSize='large'/> Details 
          </MenuItem>
          :         
          <MenuItem component={Link} to={ `/organizations/${organizationId}/collections/${courseId}/collectible/${id}/edit` } disableRipple>
            <EditIcon fontSize='large'/> Edit
          </MenuItem>
        }

        <MenuItem onClick={handleCopyLink} disableRipple>
            <LinkIcon fontSize='large'/>
            Copy Link
        </MenuItem>

        { showDeleteButton &&
        <MenuItem onClick={onConfirmDelete} disableRipple>
            <DeleteIcon fontSize='large'/>
            Delete
        </MenuItem>
        }
    </div>
  )
}

Teacher.propTypes = {
  organizationId: PropTypes.string,
  courseId: PropTypes.string,
  id: PropTypes.string,
  showDeleteButton: PropTypes.bool,
  published: PropTypes.bool,
  claim_token: PropTypes.string,
  organization_slug: PropTypes.string,
  onConfirmDelete: PropTypes.func
};

export default Teacher;